module.exports = __webpack_public_path__ + "static/img/list-img0.40e75c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/list-img0.jpg
// module id = eREi
// module chunks = 1